import EasyMDE from 'easymde';
window.EasyMDE = EasyMDE;

function CreateEasyMDE(e) {
    var elementOptions = e.dataset.mde ? JSON.parse(e.dataset.mde) : {};

    var defaultOptions = {
        element: e,
        renderingConfig: {
            singleLineBreaks: false,
            codeSyntaxHighlighting: true,
        },
        hideIcons: ["fullscreen", "side-by-side"],
        showIcons: ["code", "table"],
        spellChecker: false,
        previewClass: ["editor-preview", "markdown-body"]
    }

    var options = Object.assign(defaultOptions, elementOptions);
    return new EasyMDE(options);
}

document.querySelectorAll('textarea[data-mde]').forEach(function (e) {
    var defaultMessage = e.dataset.defaultMessage;
    var inputDescriptionEasymde = CreateEasyMDE(e);
    if (defaultMessage) {
        inputDescriptionEasymde.value(defaultMessage);
    }
});
